import { cap } from '../../../State'
import { translations } from '../../../translations'

/**
 * Le traduzioni della pagina: quelle comuni (`aeXxx` in `translations`) più le stringhe
 * nate dal rifacimento dell'interfaccia, che stanno qui per non toccare il file globale.
 * Una lingua senza traduzione usa l'italiano.
 */
const EXTRA = {
  IT: {
    aeModello: 'Modello',
    aeGoogle: 'Google Geocoding e Directions',
    aeGoogleAuto: 'Riusa e registra se manca',
    aeGoogleReplay: 'Solo registrazioni',
    aeGoogleRecord: 'Registra di nuovo',
    aeGoogleLive: 'Dal vivo senza registrare',
    aeAzioni: 'Azioni',
    aeRiprova: 'Riprova',
    aeElencoNonLetto: 'Non riesco a leggere le run',
    aeElencoNonLettoAiuto: 'La lista si riprova da sola ogni pochi secondi, oppure riprova subito.',
    aeExecutorAiuto: 'Controlla che l’Executor sia avviato (di default su localhost:3010).',
    aeNessunaRunAiuto:
      'Scegli un environment e gli scenari da misurare: la prima run parte subito.',
    aeLanciaPrima: 'Lancia la prima run',
    aeAzzeraFiltri: 'Azzera i filtri',
    aeFiltriAttivi: 'Filtri attivi',
    aeRunTrovate: 'run',
    aePassoEnv: 'Dove',
    aePassoScenari: 'Cosa',
    aePassoOpzioni: 'Come',
    aeScenariScelti: 'scelti',
    aeSelezionaVisibili: 'Seleziona i visibili',
    aeDeseleziona: 'Nessuno',
    aeNessunoScenario: 'Nessuno scenario con questi filtri.',
    aeSegui: 'Segui',
    aeAvanzamento: 'Avanzamento',
    aeRunAttiva: 'Run attiva',
    aeCercaScenario: 'Cerca uno scenario',
    aeSoloDaRivedere: 'Solo da rivedere',
    aeApriTutti: 'Apri tutti',
    aeChiudiTutti: 'Chiudi tutti',
    aeNessunRisultato: 'Nessuno scenario corrisponde alla ricerca.',
    aeEsecuzione: 'Esecuzione',
    aeTrascrizioneAssente:
      'Questa run non ha salvato i testi dei turni: rilanciala con «Salva le trascrizioni» per leggerli.',
    aeMigliorata: 'migliorata',
    aePeggiorata: 'peggiorata',
    aeIndistinguibile: 'indistinguibile',
    aeRispettoAPrima: 'Rispetto alla run precedente',
    aeFirmaCommit: 'Firma e commit',
    aeVerde: 'verde',
    aeRosso: 'rosso',
    aeDetagliTecnici: 'Dettagli tecnici',
    aeCaricamentoRun: 'Carico la run…',
    aeAvviaDisabilitato: 'Per avviare',
    aeCostoNonDisponibile: 'costo non disponibile'
  },
  EN: {
    aeModello: 'Model',
    aeGoogle: 'Google Geocoding and Directions',
    aeGoogleAuto: 'Replay or record if missing',
    aeGoogleReplay: 'Recordings only',
    aeGoogleRecord: 'Record again',
    aeGoogleLive: 'Live without recording',
    aeAzioni: 'Actions',
    aeRiprova: 'Retry',
    aeElencoNonLetto: 'Cannot read the runs',
    aeElencoNonLettoAiuto: 'The list retries on its own every few seconds, or retry now.',
    aeExecutorAiuto: 'Check that the Executor is running (by default on localhost:3010).',
    aeNessunaRunAiuto:
      'Pick an environment and the scenarios to measure: the first run starts right away.',
    aeLanciaPrima: 'Launch the first run',
    aeAzzeraFiltri: 'Clear filters',
    aeFiltriAttivi: 'Active filters',
    aeRunTrovate: 'runs',
    aePassoEnv: 'Where',
    aePassoScenari: 'What',
    aePassoOpzioni: 'How',
    aeScenariScelti: 'selected',
    aeSelezionaVisibili: 'Select visible',
    aeDeseleziona: 'None',
    aeNessunoScenario: 'No scenario matches these filters.',
    aeSegui: 'Follow',
    aeAvanzamento: 'Progress',
    aeRunAttiva: 'Active run',
    aeCercaScenario: 'Search a scenario',
    aeSoloDaRivedere: 'Needs review only',
    aeApriTutti: 'Expand all',
    aeChiudiTutti: 'Collapse all',
    aeNessunRisultato: 'No scenario matches the search.',
    aeEsecuzione: 'Execution',
    aeTrascrizioneAssente:
      'This run did not save the turn texts: launch it again with “Save transcripts” to read them.',
    aeMigliorata: 'improved',
    aePeggiorata: 'worse',
    aeIndistinguibile: 'indistinguishable',
    aeRispettoAPrima: 'Versus the previous run',
    aeFirmaCommit: 'Signature and commit',
    aeVerde: 'green',
    aeRosso: 'red',
    aeDetagliTecnici: 'Technical details',
    aeCaricamentoRun: 'Loading the run…',
    aeAvviaDisabilitato: 'To start',
    aeCostoNonDisponibile: 'cost not available'
  }
}

const language = cap.language.state || 'IT'

/** Le traduzioni della pagina nella lingua dell'app. */
export const t = {
  ...(translations[language] || translations.IT),
  ...(EXTRA[language] || EXTRA.IT)
}
